export default __webpack_public_path__ + "static/media/corey-resume.1b20a1ab.pdf";